<section class="register-outer">
    <!--page starts-->
    <section class="page-wrapper register-form">
        <div class="register-hero-section margin-top-152 cf">
            <div class="container">
            <div class="register-hero-detail">
                <div class="register-hero-top">
                    <div class="register-titel">
                        <h2>Register<span><img src="assets/images/ic-logo-new.png"></span></h2>
                    </div>
                </div>
                <div class="register-hero-bottom cf">
                    <http-message types="success" [data]="registerSuccess" class="err-msg-block"></http-message>
                    <http-message [type]="'error'" [data]="registerError" *ngIf="registerError" class="err-msg-block"></http-message>
                    <form class="register-hero-detail" #signupForm="ngForm" (ngSubmit)="doSignup(signupForm)">
                            <!-- <div class="register-input-box half mr">
                                
                                    <input type="text" placeholder="Title">
                                
                            </div> -->
                            <div class="register-input-box half mr">
                                <app-form-field validation="required" name="first_name" [(ngModel)]="registerRequest.first_name" class="app-group">
                                    <input appFieldInput type="text" placeholder="First Name" tabindex="1">
                                </app-form-field>
                            </div>
                            <div class="register-input-box half ">
                                <app-form-field validation="required" name="last_name" [(ngModel)]="registerRequest.last_name" class="app-group">
                                    <input appFieldInput type="text" placeholder="Last Name" tabindex="2">
                                </app-form-field>
                                
                            </div>
                            <div class="register-input-box half mr">
                                <app-form-field validation="required|email" name="email" [(ngModel)]="registerRequest.email" class="app-group">
                                    <input appFieldInput type="email" placeholder="Email (Username) *" tabindex="3">
                                </app-form-field>
                            </div>
                            
                            <div class="register-input-box half ">
                                    <app-form-field validation="required|min:8|max:10" name="phone_number" [(ngModel)]="registerRequest.phone_number" class="app-group">
                                        <!-- <input appFieldInput type="number" pattern="[0-9]{10}" id="country_code" name="" value="+91" tabindex="4" placeholder="Phone Number" tabindex="4"> -->
                                        <div class="phone-number-box login-input-style">
                                            <div class="custom-select">
                                                <ul>
                                                    <li class="custom-select-top"><a
                                                            href="javascript:void(0)"
                                                            class="selected_cont">
                                                            <p><span class="img gb"></span>
                                                                <p>
                                                        </a>
                                                        <ul class="custom-select-list">
                                                            <li>
                                                                <a href="javascript:void(0)">
                                                                    <p><span
                                                                            class="img in"></span><span
                                                                            class="name">India</span>
                                                                    </p>
                                                                    <span class="number">+91</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0)">
                                                                    <p><span
                                                                            class="img us"></span><span
                                                                            class="name">United
                                                                            States</span></p>
                                                                    <span class="number">+1</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0)">
                                                                    <p><span
                                                                            class="img gb"></span><span
                                                                            class="name">United
                                                                            Kingdom</span></p>
                                                                    <span class="number">+44</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0)">
                                                                    <p><span
                                                                            class="img af"></span><span
                                                                            class="name">Afghanistan</span>
                                                                    </p>
                                                                    <span class="number">+93</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0)">
                                                                    <p><span class="img zw"></span>
                                                                        <span
                                                                            class="name">Zimbabwe</span>
                                                                    </p>
                                                                    <span class="number">+263</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="number-box">
                                                <input type="number-text"  id="country_code" name="" value="+44"  placeholder="PHONE">
                                                <input type="hidden" id="country_name" name="" value="United
                                                Kingdo">
                                            </div>
                                            <div class="number-text">
                                                <input appFieldInput type="number" min="0" max="10" name="" tabindex="3" placeholder="PHONE">
                                            </div>
                                        </div>
                                    </app-form-field>
                               
                                
                            </div>
                            
                            <div class="register-input-box half mr">
                                <app-form-field validation="required|min:8" name="password" [(ngModel)]="registerRequest.password" class="app-group">
                                    <input appFieldInput type="password" placeholder="Password *" tabindex="5">
                                </app-form-field>
                               
                            </div>
                            <div class="register-input-box half ">
                                <app-form-field validation="required|min:8|equalto:password" name="password_confirmation" [(ngModel)]="registerRequest.password_confirmation" class="app-group">
                                    <input appFieldInput type="password" placeholder="Confirm Password *" tabindex="6">
                                </app-form-field>
                                
                            </div>
                            <div class="register-input-box full">
                                <input appFieldInput type="text" [min]="min" [max]="today" name="birth_date" max="{{todaydate}}" [(ngModel)]="registerRequest.birth_date" id="birth_date" class="form-control login-input-style" placeholder="DD/MM/YYYY" [owlDateTimeTrigger]="start_date_picker"
                                [owlDateTime]="start_date_picker">
                                <owl-date-time #start_date_picker pickerType="calendar"></owl-date-time>
                                <div class="invalid-feedback" id="birth_date_msg"></div>

                                <!-- <app-form-field validation="required|dateofbirth" name="birth_date" [(ngModel)]="registerRequest.birth_date" class="app-group">
                                    <input appFieldInput type="date" placeholder="Date of Birth" tabindex="7">
                                </app-form-field>     -->
                            </div>
                            <div class="register-input-box full">
                                
                            </div>
                            <div class="register-btn">
                                <button  (click)="nextscreen(registerRequest.first_name, registerRequest.email,registerRequest.last_name,registerRequest.birth_date,registerRequest.phone_number)">Next</button>
                                <!-- <a [class.disabled]="isDisabled(link)" (click)="nextscreen(registerRequest.first_name)">NEXT</a>  -->
                                <!-- <button type="submit"></button> -->
                            </div>
                            <div class="register-back-to">
                                <a routerLink="/login">Back to Login</a>
                            </div>
                    </form>
                </div>
            </div>
            </div>
        </div>
    </section><!-- page ends-->
    <!--page starts-->
    <section class="page-wrapper register-address">
        <div class="register-hero-section cf">
            <div class="container">
            <div class="register-hero-detail">
                <div class="register-hero-top">
                    <div class="register-titel">
                        <h2>Add Address<span><img src="assets/images/ic-logo-new.png"></span></h2>
                    </div>
                </div>
                <div class="register-hero-bottom cf">
                    <http-message types="success" [data]="registerSuccess" class="err-msg-block"></http-message>
                    <http-message [type]="'error'" [data]="registerError" *ngIf="registerError" class="err-msg-block"></http-message>
                    <form class="register-hero-detail" #signupForm="ngForm" (ngSubmit)="doSignup(signupForm)">
                            <div class="register-input-box half mr">
                                <app-form-field validation="required" name="address1" [(ngModel)]="registerRequest.address1" class="app-group">
                                    <input appFieldInput type="text" placeholder="LINE 1" tabindex="1">
                                </app-form-field>
                            </div>
                            <div class="register-input-box half">
                                <app-form-field  name="address2" [(ngModel)]="registerRequest.address2" class="app-group">
                                    <input appFieldInput type="text" placeholder="LINE 2 [OPTIONAL]" tabindex="2">
                                </app-form-field>
                            </div>
                            <div class="register-input-box half mr">
                                <app-form-field validation="required" name="city" [(ngModel)]="registerRequest.city" class="app-group">
                                    <input  appFieldInput type="text" placeholder="City" tabindex="3">
                                </app-form-field>
                            </div>
                            <div class="register-input-box half">
                                <app-form-field validation="required" name="county" [(ngModel)]="registerRequest.state" class="app-group">
                                    <input appFieldInput type="text" placeholder="County" tabindex="4">
                                </app-form-field>
                            </div>
                            <div class="register-input-box half mr">
                                <app-form-field validation="required" name="country_name" [(ngModel)]="registerRequest.country_name" class="app-group">
                                    <input appFieldInput type="text" placeholder="Country" tabindex="5">
                                </app-form-field>
                            </div>
                            <div class="register-input-box half">
                                <app-form-field validation="required" name="postcode" [(ngModel)]="registerRequest.pincode" class="app-group">
                                    <input appFieldInput type="text" placeholder="Postcode" tabindex="6">
                                </app-form-field>
                            </div>
                            <div class="register-btn">
                                <button type="submit">SUBMIT</button>
                            </div>
                            <div class="register-back-to">
                                <a href="#" class="back-form">Back to Screen</a>
                                <a routerLink="/login">Back to Login</a>
                            </div>
                    </form>
                </div>
            </div>
            </div>
        </div>
    </section><!-- page ends-->
</section>